export default __webpack_public_path__ + "static/media/flag_en.f49fc778.png";